'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Video
 *
 * @description:
 * This module is responsible for handling video elements.
 * It adds event listeners to video elements to play the video when overlay is clicked.
 *
 * js-video-active is helper class which is needed to prevent clicks, when the video is in a slider for example.
 * If only showing video, add this class as default
 *
 * @example:
 * <div data-video-element>
 *  <video src="video.mp4"></video>
 *  <div class="js-video-active" data-video-element-overlay></div>
 * </div>
 */
const video = {
    addVideoElement: function (element) {
        console.log('addVideoElement()');
        const video = element.querySelector('video');
        const overlay = element.querySelector('[data-video-element-overlay]');
        const playVideo = () => {
            if (overlay.classList.contains('js-video-active')) {
                video.play();
                video.focus();
                video.setAttribute('controls', '');
                overlay.remove();
                video.removeEventListener('click', playVideo);
                video.removeEventListener('keyup', keyPressOnPlay);
                overlay.removeEventListener('click', playVideo);
            }
        };
        const keyPressOnPlay = (e) => {
            if (e.key === 'Enter') {
                playVideo();
            }
        };
        video.addEventListener('click', playVideo);
        video.addEventListener('keyup', keyPressOnPlay);
        overlay.addEventListener('click', playVideo);
    },
    init: function () {
        document.querySelectorAll('[data-video-element]').forEach(video => {
            this.addVideoElement(video);
        });
    }
};
exports.default = video;
